import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss'
})
export class TextInputComponent {
  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: false }) errorMessage?: string;
  @Input({ required: true }) control: FormControl;
  @Input({ required: false }) type: "text" | "number" | "password";
  @Input({ required: false }) id: string;


  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }
}
